export default "__VITE_PUBLIC_ASSET__11a22393__"